import React, { useEffect, useRef, useState } from 'react';
import { HotTable } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';

import { registerCustomElements } from './config/handsontable';
import { createDynamicStyles } from './styles/tableStyles';
import { useTableData } from './hooks/useTableData';
import { useTableSettings } from './hooks/useTableSettings';
import { useSharedShipmentData } from './hooks/useProjectShipmentData';

registerAllModules();
registerCustomElements();

// Main table component
const SharedTableContent: React.FC = () => {
  const hotRef = useRef<any>(null);

  const { shipments, fields, trackingJobsMap } = useSharedShipmentData(true);

  const { tableData, shipmentsMap } = useTableData(shipments, fields);

  const [stylesReady, setStylesReady] = useState(false);

  const { settings } = useTableSettings({
    fields,
    tableData,
    shipmentsMap,
    trackingJobsMap,
    hotRef,
  });

  useEffect(() => {
    if (settings) {
      createDynamicStyles();
      requestAnimationFrame(() => setStylesReady(true));
    }
  }, [settings]);

  return (
    <div>
      <div className={`transition-opacity duration-500 ease-in-out ${stylesReady ? 'opacity-100' : 'opacity-0'}`}>
        <HotTable
          ref={hotRef}
          {...settings}
          licenseKey="non-commercial-and-evaluation"
          hiddenColumns={{ columns: [0], indicators: false }} // Hide ID column
        />
      </div>
    </div>
  );
};

const SharedTable: React.FC = () => {
  return <SharedTableContent />;
};

export default SharedTable;
